import { render } from "./footerSection.vue?vue&type=template&id=33c8c79e&scoped=true"
import script from "./footerSection.vue?vue&type=script&lang=js"
export * from "./footerSection.vue?vue&type=script&lang=js"

import "./footerSection.vue?vue&type=style&index=0&id=33c8c79e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c8c79e"]])

export default __exports__